import { AlertTriangle, CircleCheck, Info } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { cn } from '@/lib/utils';

interface InlineNoticeProps {
  tone?: 'info' | 'success' | 'warning' | 'destructive';
  title?: string;
  className?: string;
  children?: React.ReactNode;
}

const TONE = {
  info: { className: 'border-primary/20 bg-accent [&>svg]:text-primary', icon: Info },
  success: { className: 'border-success/25 bg-success/10 [&>svg]:text-success', icon: CircleCheck },
  warning: {
    className: 'border-warning/25 bg-warning/10 [&>svg]:text-warning',
    icon: AlertTriangle,
  },
  destructive: {
    className: 'border-destructive/25 bg-destructive/10 [&>svg]:text-destructive',
    icon: AlertTriangle,
  },
} as const;

/** 인라인 안내 — Admin Kit Alert(아이콘 + 제목 + 본문)에 tone 면만 얹는다. 본문 글자는 foreground 유지. */
export function InlineNotice({ tone = 'info', title, className, children }: InlineNoticeProps) {
  const { className: toneClass, icon: Icon } = TONE[tone];
  return (
    <Alert role={tone === 'destructive' ? 'alert' : 'status'} className={cn(toneClass, className)}>
      <Icon className="size-4" aria-hidden="true" />
      {title && <AlertTitle>{title}</AlertTitle>}
      {children && <AlertDescription>{children}</AlertDescription>}
    </Alert>
  );
}
